import React from "react";
import {
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Controls from "../../components/controls/Controls";
import CheckIcon from "@material-ui/icons/Check";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));
export default function QuickDetailLineView(props) {
    const {
        invoiceDetail,
        open,
        handleClose,
        displayItemCodeField,
        displayPriceField
    } = props;
    const classes = useStyles();
    return (

        <Dialog open={open} onClose={handleClose}
                maxWidth='md'
                fullWidth={true}
                aria-labelledby="form-dialog-title">
            <DialogTitle disableTypography>
                <Typography variant='h6' color='textSecondary'>
                    Transaction details
                </Typography>
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                {displayItemCodeField && <TableCell>Item </TableCell>}
                                <TableCell>Description</TableCell>
                                <TableCell align='right'>Quantity</TableCell>
                                {displayPriceField && <TableCell align='right'>Price</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {invoiceDetail && invoiceDetail.lines && invoiceDetail.lines.length > 0 ? invoiceDetail.lines.map((detailLine) => {

                                return (
                                    <TableRow key={detailLine.id}>


                                        {displayItemCodeField && <TableCell component="th"
                                                                            scope="detailLine">{detailLine.item !== '/C' && detailLine.item !== '/F' ? detailLine.item : null}</TableCell>}
                                        <TableCell>{detailLine.description}</TableCell>
                                        <TableCell
                                            align="right">{detailLine.item === '/C' ? '' : (detailLine.quantity)} </TableCell>
                                        {displayPriceField && <TableCell
                                            align="right">{detailLine.item === '/C' ? '' : ('$' + detailLine.extension.toFixed(2))} </TableCell>}
                                    </TableRow>
                                )

                            }) : <TableRow>
                                <TableCell colSpan={4} align='center'>
                                    No records found
                                </TableCell>
                            </TableRow>}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Controls.Button
                    startIcon={<CheckIcon/>}
                    autoFocus
                    onClick={handleClose}
                    text="Done"
                />
            </DialogActions>
        </Dialog>
    );
}
